export const roles = {
  TECH_APP_ADMIN: 'App_TechApp_Admin',
  BRINKS_TECH: 'App_Brinks_Tech',
  DEALER_TECH: 'App_Dealer_Tech',
}

export const phoneNumbers = {
  SCHEDULING: '866-961-2242',
  FIELD_TECH_DISPATCH: '800-418-2598',
  GENERAL: '800-615-3844',
}
